<template>
    <div class="main_content">
        <div class="item_404">404</div>
        <div>Página no encontrada</div>
        <div>
            <v-btn 
                block 
                rounded="xl" 
                size="large" 
                prepend-icon="mdi-arrow-left" 
                class="text-none mt-5"
                color="indigo-darken-3"
                @click="$router.push('/SGCCV')">Regresar al inicio
            </v-btn>
        </div>
    </div>
</template>

<style scoped>
    .main_content {
        width: 100%;
        height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .item_404 {
        font-size: 70pt;
    }
</style>
